<template>
  <section id="cashregister"
           class="cashregister">
    <div>
      <transition name="fade" mode="out-in" >
        <div class="section-top-row">
          <div class="row row-narrow align-items-center no-print position-relative">
            <div class="col order-md-0 order-0">
              <h1>{{ $t('cashdesk') }}</h1>
            </div>
          </div>
        </div>
      </transition>
      <div class="sub-menu no-print">
        <template v-for="(m, mind) in menu">
          <router-link :to="{ name: m.to }"
                       v-if="!m.right || rights.includes(m.right)"
                       :key="`cashdesk-link-${mind}}`">
            {{ $t(m.title) }}
          </router-link>
        </template>
      </div>
    </div>
    <router-view/>
  </section>
</template>

<script setup>
import { useStore } from "vuex"
import { computed } from "vue"

const store = useStore()

const rights = computed(() => store.state.auth.rights)
const menu = computed(() => {
  return [
    { to: 'CashregisterDashboard', title: 'dashboard', right: 'cashregister_dashboard' },
    { to: 'CashregisterCashReport', title: 'cashdesk_report', right: 'cashregister_cashreport' },
  ]
})
</script>
